import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import logo from "../../../assets/img/Fronic_Logo_white.png";
import { useHistory } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import { toastError, toastSuccess } from "../../../utils";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const StyledButton = styled(Button)({
  fontFamily: "'DM Sans', sans-serif",
  background:
    "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
  fontSize: 18,
  height: 50,
  textTransform: "capitalize",
});

const CssTextField = styled(TextField)({
  // background: "transparent",
  fontFamily: "'DM Sans', sans-serif",
  color: "#fff",
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    // color: '#10baa8',
    color: "white",
  },
  "& label.Mui-focused": {
    // color: '#10baa8',
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "red",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#10baa8",
    },
  },
});

export default function ForgotPassword(props) {
  const {
    user,
    errors,
    onChangeHandler,
    loginLoader,
    setShowforgot,
    onSendForgotOTP,
  } = props;
  const history = useHistory();
  const [isCapchaGood, setIsCapchaGood] = useState(false);
  //---capcha code starts--------------------------

  async function onChangeCapcha(value) {
    await axios
      .post(
        `https://backend.fronicmedia.com/api/capchaVerification?responseCapcha=${value}`
      )
      .then((res) => {
        if (res?.data?.body?.success === false) {
          setIsCapchaGood(false);
          toastError("Captcha expired. Try again ?");
        } else if (res?.data?.body?.success === true) {
          setIsCapchaGood(true);
          toastSuccess("Good to see you Human.");
        } else {
          toastError("Captcha verification failed.");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //---code ends-----------------------------------

  return (
    <div className="login-div">
      <Grid container>
        <Grid item xs={12}>
          <div className="logo-image-div">
            <img src={logo} alt="" />
          </div>
        </Grid>

        <Grid item xs={12}>
          <Box pt={5} pb={3}>
            <CssTextField
              label="Email"
              variant="outlined"
              id="custom-css-outlined-input"
              value={user.email}
              error={!!errors.email}
              onChange={(e) => onChangeHandler("email", e)}
              fullWidth
              autoFocus
            />
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <ReCAPTCHA
            sitekey="6LdUG_gjAAAAAEXj3qkc5X-jlW4Z4JOpqPiopmmm"
            onChange={onChangeCapcha}
          />
        </Grid>

        <Grid item xs={12}>
          <Box pt={4}>
            <StyledButton
              variant="contained"
              color="primary"
              onClick={onSendForgotOTP}
              fullWidth
              disabled={!isCapchaGood}
            >
              {loginLoader ? (
                <CircularProgress size={25} style={{ color: "white" }} />
              ) : (
                "Send OTP"
              )}
            </StyledButton>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box pt={1} pb={4}>
            <p
              className="dont-have-account"
              onClick={() => setShowforgot(false)}
            >
              Go back to Login
            </p>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}
